import { render, staticRenderFns } from "./GhShopListItem.vue?vue&type=template&id=f3c06176&scoped=true&"
import script from "./GhShopListItem.vue?vue&type=script&lang=js&"
export * from "./GhShopListItem.vue?vue&type=script&lang=js&"
import style0 from "./GhShopListItem.vue?vue&type=style&index=0&id=f3c06176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c06176",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VCard,VCardActions,VCardTitle,VFadeTransition,VHover,VIcon,VImg,VOverlay})
